import React from 'react';
import PropTypes from 'prop-types';

import styles from '../../../../stylesheets/public/layouts/AboutPage.module.postcss';
import ResponsiveImg from '../../shared/ResponsiveImg';

function CtaImage({ image, noLazy = false, isResponsive = false }) {
  return (
    <div className={styles.Cta_image}>
      { !isResponsive &&
        <img src={image} alt='' loading={noLazy ? 'eager' : 'lazy'} fetchpriority={noLazy ? 'high' : 'low'} />
      }

      { isResponsive &&
        <ResponsiveImg
          src={image}
          widths={[400, 600, 800, 1000]}
          sizes='(max-width: 900px) 100vw, 50vw'
          alt=''
          loading={noLazy ? 'eager' : 'lazy'}
          fetchpriority={noLazy ? 'high' : 'low'}
        />
      }
    </div>
  );
}

CtaImage.propTypes = {
  image: PropTypes.string.isRequired,
};

export default CtaImage;
